'use client'

import dynamic from 'next/dynamic'

export const ClientSideLegacyTrialListingPage = dynamic(
  async () =>
    import('@components/app/ListingPage/LegacyTrialListingPage').then(
      (mod) => mod.LegacyTrialListingPage,
    ),
  { ssr: false },
)
